import { computed } from 'vue';
import { useFilters } from '@/Composables/Filters/useFilters.js';
import {
    buildDefaultProjectsFilterParams,
    buildProjectsCurrentFilter,
    removeProjectsSelectedFilter,
    buildProjectSortSchemaList,
    buildProjectsFilterList,
} from '@/Utils/Views/BackerCenterViewYourProjectsUtility';
import { apiClient } from '@/Clients/ApiClient';
import UsersService from '@/Services/UsersService';
import CreatorsService from '@/Services/CreatorsService.js';
import Resources from '@/Resources.js';
import { projectSearchSortType } from '@/Models';
import { convertArrayParamsToCommaSeparatedList } from '@/Utils/FiltersUtility.js';

const usersService = new UsersService(apiClient);
const creatorsService = new CreatorsService(apiClient);

async function searchCreator(term, model) {
    if (!term && !model?.name) return Promise.resolve([]);

    const result = await creatorsService.searchCreatorsByTerm(term || model.name);
    return result.data;
}

export function useBackerCenterProjectsFilters() {
    const baseFilters = useFilters({
        buildDefaultFilterParams: buildDefaultProjectsFilterParams,
        buildCurrentFilter: buildProjectsCurrentFilter,
        buildFilterList: () => buildProjectsFilterList(searchCreator),
        buildSortList: buildProjectSortSchemaList,
        removeSelectedFilter: removeProjectsSelectedFilter,
        storageKey: 'projectsSearchParams',
        apiLoadMethod: async (params, loadMore) => {
            const mappedParams = {
                ...params,
                creatorID: params.creator?.creatorID || null,
                creatorName: params.creator?.name || null,
            };
            const formattedParams = convertArrayParamsToCommaSeparatedList(mappedParams);
            const { data } = await usersService.getBackerProjects(formattedParams);
            return {
                ...data.projects,
                searchResultQuery: data.searchResultQuery,
                params: data.params,
            };
        },
        resources: { ...Resources.Search, ...Resources.Common },
        sortEnum: projectSearchSortType,
    });

    const hasProjects = computed(() => baseFilters.hasItems.value);

    return {
        ...baseFilters,
        hasProjects,
    };
}